import { render, staticRenderFns } from "./IcoArrowOutUpRightSquare.vue?vue&type=template&id=bc3c78c2"
import script from "./IcoArrowOutUpRightSquare.vue?vue&type=script&lang=js"
export * from "./IcoArrowOutUpRightSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports